import { stateContext } from '../services/hooks/useStore';
import { api, apiV2, aqRelatorios, aqReports, aqReportsV2, newApi } from '../services/utils';
import NotificacaoService from '../services/NotificacaoService';


/**
 * Função que checa se o token salvo no `localStorage` é válido.
 */
export default async function checkUser(): Promise<void | null> {
  const store = stateContext.state;

  if (window.location.pathname !== '/') {
    try {
      // @ts-ignore
      api.defaults.headers.common['Authorization'] = store.token as string;
      apiV2.defaults.headers.common['Authorization'] = store.token as string;
      newApi.defaults.headers.common['Authorization'] = store.token as string;
      aqRelatorios.defaults.headers.common['Authorization'] = store.token as string;
      aqReports.defaults.headers.common['Authorization'] = store.token as string;
      aqReportsV2.defaults.headers.common['Authorization'] = store.token as string;
      newApi.defaults.headers.common['Authorization'] = store.token as string;

      const request = await api.get('/auth/me/');
      const userData: User = request.data;

      if (userData.plano.id === 4) {
        const propriedade = localStorage.getItem('propriedade');
        let propriedadeId: number;

        store.setLogado(userData);

        if (propriedade) {
          if (store.usuario.propriedades.filter((prop) => prop.ativo && prop.id === parseInt(propriedade)).length > 0) {
            propriedadeId = parseInt(propriedade);
            await store.setPropriedade(propriedadeId);
          } else {
            propriedadeId = store.usuario.propriedades.filter((propriedade) => propriedade.ativo)[0].id;
            await store.setPropriedade(propriedadeId);
            localStorage.removeItem('propriedade');
          }
        } else {
          propriedadeId = store.usuario.propriedades.filter((propriedade) => propriedade.ativo)[0].id;
          await store.setPropriedade(propriedadeId);
          localStorage.removeItem('propriedade');
        }

        // Only check for notifications if they haven't been loaded yet
        if (store.notificacoes.length === 0) {
          try {
            const notificacoes = await NotificacaoService.buscarNotificacoes(propriedadeId);
            store.setNotificacoes(notificacoes);
            store.setNotificacoesNaoLidas(notificacoes.filter(n => !n.lido).length);
          } catch (error) {
            console.error('Erro ao buscar notificações:', error);
          }
        }
      } else {
        alert('Entre em contato conosco pelo whatsapp para liberar seu plano!');
      }
    } catch (error) {
      window.location.href = '/';
    }
  } else return null;

  store.toggleLoader();
}
